<template>
  <div style="height: 100%;background-color: #fbfbfb">
    <div style="height: 50px;padding-top: 20px;margin: 0 20px">
      <el-button type="primary" plain icon="el-icon-plus" @click="addBtn">新增</el-button>
    </div>
    <div style="height: calc(100% - 120px);margin: 0 20px">
      <el-table :data="tableData" border highlight-current-row ref="singleTable" height="100%">
        <el-table-column
          type="index"
          label="序号"
          width="70"
          align="center">
        </el-table-column>
        <el-table-column
          prop="name"
          label="食材名称"
          min-width="100"
          align="center">
        </el-table-column>
        <el-table-column
          label="食材单位"
          min-width="80"
          align="center">
          <template slot-scope="scope">
            <span>{{getUnitName(scope.row.unitid)}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="val"
          label="数量"
          min-width="80"
          align="center">
        </el-table-column>
        <el-table-column
          label="食材供应商"
          min-width="90"
          align="center">
          <template slot-scope="scope">
            <span>{{getVendorName(scope.row.vendorid)}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="餐厅"
          min-width="80"
          align="center">
          <template slot-scope="scope">
            <span>{{getRestaurantName(scope.row.restaurantid)}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="120">
          <template slot-scope="scope">
            <i title="编辑" class="el-icon-edit" style="cursor: pointer; font-size: 18px;color: #1ae517" @click="editBtn(scope.row)"></i>
            <i title="删除" class="el-icon-delete" style="cursor: pointer; font-size: 18px;color: red" @click="delBtn(scope.row)"></i>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div style="margin-top: 10px;height: 40px;text-align: center">
      <el-pagination v-fixZoom @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
                     :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalCells"
                     layout="total, sizes, prev, pager, next, jumper">
      </el-pagination>
    </div>
    <el-dialog :visible.sync="addEditShow" v-if="addEditShow" width="500px"
               :show-close="true" :close-on-click-modal="false" center class="all-open">
      <div class="title-top-alarm">
        <span>{{addEditTitle}}</span>
        <div class="line-title"></div>
      </div>
      <add-edit-material :addEditObj="addEditObj" v-model="addEditShow" @updateTable="updateTable"></add-edit-material>
    </el-dialog>
  </div>
</template>

<script>
import {queryrestaurant, queryingredientunit, queryingredient, queryingredientvendor, deleteingredient} from '../../api/yanglaoyuan'
import addEditMaterial from './components/addEditMaterial'
export default {
  name: 'rawMaterial',
  components: {addEditMaterial},
  data () {
    return {
      restaurants: [], // 餐厅
      ingredientunits: [], // 食材单位
      ingredientvendors: [], // 食材供应商
      entityId: 0,
      pageSize: 10,
      currentPage: 1,
      totalCells: 0,
      tableData: [],
      addEditTitle: '',
      addEditShow: false,
      addEditObj: {
        restaurants: [],
        ingredientunits: [],
        ingredientvendors: [],
        isAdd: true,
        row: ''
      }
    }
  },
  created () {
    this.entityId = this.$store.state.user.LoginResp.entity_id
    this.getRestaurants()
  },
  methods: {
    // 餐厅
    getRestaurants () {
      let params = {
        size: 9999,
        page: 1
      }
      let data = {
        eid: this.entityId
      }
      queryrestaurant(params, data).then(res => {
        this.restaurants = res.data.restaurants
        this.addEditObj.restaurants = res.data.restaurants
        this.getunits()
      })
    },
    // 单位
    getunits () {
      queryingredientunit().then(res => {
        this.ingredientunits = res.data.ingredientunits
        this.addEditObj.ingredientunits = res.data.ingredientunits
        this.getIngredientVendorsData()
      })
    },
    // 供应商
    getIngredientVendorsData () {
      let params = {
        size: 9999,
        page: 1
      }
      let data = {
        eid: this.entityId
      }
      queryingredientvendor(params, data).then(res => {
        this.ingredientvendors = res.data.ingredientvendors
        this.addEditObj.ingredientvendors = res.data.ingredientvendors
        this.getTableData()
      })
    },
    getTableData () {
      let params = {
        size: this.pageSize,
        page: this.currentPage
      }
      let data = {
        eid: this.entityId
      }
      queryingredient(params, data).then(res => {
        this.tableData = res.data.ingredients
        this.totalCells = res.data.cnt
      })
    },
    getUnitName (id) {
      let name = id
      for (let i = 0; i < this.ingredientunits.length; i++) {
        if (id === this.ingredientunits[i].id) {
          name = this.ingredientunits[i].name
        }
      }
      return name
    },
    getRestaurantName (id) {
      let name = id
      for (let i = 0; i < this.restaurants.length; i++) {
        if (id === this.restaurants[i].id) {
          name = this.restaurants[i].name
        }
      }
      return name
    },
    getVendorName (id) {
      let name = id
      for (let i = 0; i < this.ingredientvendors.length; i++) {
        if (id === this.ingredientvendors[i].id) {
          name = this.ingredientvendors[i].name
        }
      }
      return name
    },
    addBtn () {
      this.addEditTitle = '新增食材'
      this.addEditObj.isAdd = true
      this.addEditObj.row = ''
      this.addEditShow = true
    },
    editBtn (row) {
      this.addEditTitle = '编辑食材'
      this.addEditObj.isAdd = false
      this.addEditObj.row = row
      this.addEditShow = true
    },
    delBtn (row) {
      this.$confirm('此操作将永久删除该食材【' + row.name + '】, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        let data = {
          id: row.id
        }
        deleteingredient(data).then(res => {
          this.$notify({title: '成功', message: '成功删除食材', type: 'success', duration: 2000})
          if (this.tableData.length === 1 && this.currentPage > 1) {
            this.currentPage--
          }
          this.getTableData()
        })
      })
    },
    updateTable () {
      this.getTableData()
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.getTableData()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.getTableData()
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/rawMaterial.vue